import React from 'react';
import { Col, Row } from 'antd';

import { ScoreChip, ScoreLabel } from './styles';

const SCORE_GUTTER = 8;

interface ScoreRowProps {
	label: string;
	value: number;
}

export function ScoreRow({ label, value }: Readonly<ScoreRowProps>): JSX.Element {
	return (
		<Row align="top" gutter={[SCORE_GUTTER, 0]} wrap={false}>
			<Col>
				<ScoreLabel>{`${label}:`}</ScoreLabel>
			</Col>
			<Col>
				<ScoreChip>{value}</ScoreChip>
			</Col>
		</Row>
	);
}
